import React from 'react';
import styled from 'astroturf/react';

import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { Icon } from 'js/design_system/Icon';

import routes from 'js/core_pre_webpack/routes';

import { IconAnchor, IconContainer, IconLabel } from './buttonStyles';
import _Container from "GrantsMarketingButton-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/GrantsMarketingButton.tsx?styleId=Container";


export const grantsMarketingIconButton = (
  <ImpressionWatcher key="grantMultiplier" source="grantai.nav_button">
    <IconAnchor
      href={routes.grant_multiplier_landing_url({
        from_navbar: true,
        trigger: 'nav',
      })}
    >
      <IconContainer>
        <Icon name="paid" size={24} />
      </IconContainer>
      <IconLabel>Grants</IconLabel>
    </IconAnchor>
  </ImpressionWatcher>
);

export function GrantsMarketingButton() {
  return (
    <ImpressionWatcher source="grantai.prominent_nav_button">
      <Container>
        <ButtonLink
          href={routes.grant_multiplier_landing_url({
            from_navbar: true,
            trigger: 'nav',
          })}
          icon="paid"
          size="sm"
        >
          See grant matches
        </ButtonLink>
      </Container>
    </ImpressionWatcher>
  );
}

// Hide button on certain screen widths so it doesn't cut off the search bar placeholder text
const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});
